import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	teaserItem: 'm-customer-lounge-brand-product-table__item',
	stateHidden: 'h-visuallyhidden',
	loadMoreButton: 'js-load-more-button',
	loadMoreBar: 'js-load-more-bar'
};

@createModule('CustomerLoungeBrandProductTable')
/**
 * @author 
 */

export class CustomerLoungeBrandProductTable extends TerrificSpec {
	$ctx: JQuery;
	isOpen: boolean;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.isOpen = false;
		this._handleApplicationTeaserLoadMore();

		resolve();
	}
	stop() {}

	_handleApplicationTeaserLoadMore() {
		// if this an Application/Evergreen and not one of the other teasers and it has not yet been opened:
		if (typeof this.$ctx.data('shown-teasers') !== 'undefined' && this.isOpen === false) {
			const $teaserItems = this.$ctx.find(`.${classes.teaserItem}`);
			let minOfShowTeasers = this.$ctx.data('shown-teasers');
			let PageSizeLoadMore = this.$ctx.data('load-items');

			if ($teaserItems.length <= minOfShowTeasers) {
				this.$ctx.find(`.${classes.loadMoreBar}`).addClass(classes.stateHidden);
				$(window).trigger('NavigationInPage:reInitNoClick');
			} else {
				minOfShowTeasers++;
				$teaserItems.filter(`:nth-child(n + ` + minOfShowTeasers + `)`).addClass(classes.stateHidden);
				$(window).trigger('NavigationInPage:reInitNoClick');

				let currentShowTeasers = minOfShowTeasers -1;
				this.$ctx.find(`.${classes.loadMoreButton}`).on('click', (ev: any) => {
					let allOfShowTeasers = currentShowTeasers + PageSizeLoadMore;
					for( var i=0; i<allOfShowTeasers; i++ ){
						$teaserItems.eq(i).removeClass(classes.stateHidden);
						currentShowTeasers = allOfShowTeasers;
						if(allOfShowTeasers >= $teaserItems.length) {
							$(ev.currentTarget)
								.parent(`.${classes.loadMoreBar}`)
								.addClass(classes.stateHidden);

							this.isOpen = true;
						}
					}
				});
			}
		}
	}
}
